<template>
    <Content>
        <Modal
            modal_id="modal_tell_me_when_you_arrive"
            max_width_lg="500px"
            max_width_xl="500px"
        >
            <template #header>
                <secondary-title>Avise-me quando chegar!</secondary-title>
            </template>
            <span>
                Preencha os campos abaixo para ser notificado quando este
                produto estiver disponível.
            </span>
            <form @submit.prevent="submit">
                <LoadingApp :isLoading.sync="isLoading" :is_full_page="true" />
                <StyleInputGroup>
                    <label for="tell_me_name">Nome</label>
                    <input
                        type="text"
                        placeholder="Nome"
                        id="tell_me_name"
                        name="tell_me_name"
                        v-model="form.name"
                    />
                    <div v-if="$v.form.name.$error" class="required">
                        * Nome obrigatório
                    </div>
                </StyleInputGroup>
                <StyleInputGroup>
                    <label for="tell_me_email">Email</label>
                    <input
                        type="text"
                        placeholder="email@seudominio"
                        id="tell_me_email"
                        name="tell_me_email"
                        v-model="form.email"
                    />
                    <div
                        v-if="$v.form.email.$error && !$v.form.email.required"
                        class="required"
                    >
                        * Email obrigatório
                    </div>
                    <div
                        v-if="$v.form.email.$error && !$v.form.email.email"
                        class="required"
                    >
                        * Email inválido
                    </div>
                </StyleInputGroup>

                <PrimaryButton type="submit">
                    Enviar
                </PrimaryButton>
            </form>
        </Modal>
    </Content>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { CSecondaryTitle } from "../../Styles/Components/styled";
import { PrimaryButton, StyleInputGroup } from "../../Styles/Extends/styled";
import { Content } from "./style";
import { required, email } from "vuelidate/lib/validators";
import Modal from "../../Modal";
import LoadingApp from "../../LoadingApp.vue";
import { swall } from "../../../services/sweetAlert";

export default {
    name: "ModalTellMeWhenYouArrive",
    components: {
        Content,
        LoadingApp,
        Modal,
        PrimaryButton,
        StyleInputGroup,
        "secondary-title": CSecondaryTitle
    },
    data() {
        return {
            isLoading: false
        };
    },
    validations: {
        form: {
            name: {
                required
            },
            email: {
                required,
                email
            }
        }
    },
    methods: {
        ...mapActions("tellMeWhenArrive", [
            "saveSubscribeTellMeWhenArrive",
            "submitSaveSubscribeTellMeWhenArrive",
            "setResetModal"
        ]),
        async submit() {
            this.isLoading = true;

            if (this.$v.$invalid) {
                this.isLoading = false;
                swall("Preencha os campos corretamente!", true);
                this.$v.$touch();
                return;
            }
            await this.submitSaveSubscribeTellMeWhenArrive(this.form)
                .then(() => {
                    this.isLoading = false;
                    this.$v.$reset();
                    this.$root.closeModalApp("modal_tell_me_when_you_arrive");
                    swall(
                        "Assinatura realizada com sucesso!",
                        false,
                        "check",
                        "success"
                    );
                })
                .catch(error => {
                    this.isLoading = false;
                    swall(error?.msg ?? error?.message ?? error, true);
                });
        }
    },
    watch: {
        reset_modal(value) {
            if (value) {
                this.$v.$reset();
                this.setResetModal(false);
            }
        }
    },
    computed: {
        ...mapState("location", [
            "location",
            "street_name",
            "street_number",
            "neighborhood",
            "postal_code",
            "city",
            "uf",
            "country",
            "latitude",
            "longitude"
        ]),
        ...mapState("tellMeWhenArrive", ["form", "reset_modal"])
    }
};
</script>
